import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@store/store';
import { UndeliveredParams } from '@api/order-reporting/types/UndeliveredParams';
import { DateRange } from '@project-types/DateRange';



export const selectGridData = (state: RootState) => state.reportingUndelivered.gridData;
export const selectDateRange = (state: RootState) => state.reportingUndelivered.dateRange;
export const selectSelectedPlant = (state: RootState) => state.reportingUndelivered.selectedPlant;
export const selectPhase = (state: RootState) => state.reportingUndelivered.phase;



export const selectValidParams = createSelector(
	[
		selectDateRange,
		selectSelectedPlant,
		selectPhase,
	],(
		dateRange: DateRange | null,
		selectedPlant: string | null,
		phase: string | null,
	) => {
		if (!dateRange) return null;
		let validParams: UndeliveredParams = {
			dateFrom: dateRange.from,
			dateTo: dateRange.to,
			...(selectedPlant && { dc: selectedPlant }),
			...(phase && { phase: phase }),
		};
		return validParams;
	}
);